import React from "react";
import { useState } from "react";
import "./billingForm.scss";
import { toast } from "react-toastify";
import countriesData from "@/data/countries.json";
import axios from "axios";
import { MdEdit } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { useRouter } from "next/navigation";

// toast options
const toastOptions = {
  position: "top-center",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
};

export default function BillingInfoForm({
  formData,
  setFormData,
  setIsForm,
  userBillingInfo,
  currentBilling,
  setCurrentBilling,
  isShowOldBillingInfo,
  setIsShowOldBillingInfo,
  userDataSelector,
  setIsGetBillingData,
}) {
  const [states, setStates] = useState([]);
  const router = useRouter();
  const [isFormUpdate, setIsFormUpdate] = useState(false);

  // handle form data change
  const handleChange = (event) => {
    if (!userDataSelector) {
      router.push("/signin?path=%2Fpricing");
      return;
    }
    const { name, value, type, checked } = event.target;
    if (name === "contact") {
      if (value.length > 10) {
        return;
      }
    }
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // handle country change
  const handleCountryChange = (event) => {
    const { value } = event.target;

    const countryData = countriesData.find((c) => c.name === value);

    setStates(countryData ? countryData.states : []);

    setFormData({
      ...formData,
      country: value,
    });
  };

  // handle state change
  const handleStateChange = (event) => {
    const { value } = event.target;
    setFormData({ ...formData, state: value });
  };

  // handle address change
  const handleAddressChange = (item) => {
    // console.log(item);
    setCurrentBilling(item);
  };

  // handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userDataSelector) {
      router.push("/signin?path=%2Fpricing");
      return;
    }
    if (formData.contact.length < 10) {
      // console.log("fill all the field");
      toast.warning(
        "Please enter a valid 10-digit mobile number",
        toastOptions
      );
      return;
    }

    if (!formData.country || !formData?.state) {
      toast.warning("Please Select Country or State!", toastOptions);
      return;
    }

    if (formData?.isGstRequired) {
      if (!formData.gstCompanyName || !formData.gstNumber) {
        toast.warning("Please Add GST Info", toastOptions);
        return;
      }
    }

    const data = {
      name: formData.name,
      userId: userDataSelector?._id,
      contact: Number(formData.contact),
      email: formData.email,
      gst: formData.isGstRequired,
      pincode: Number(formData.pincode),
      country: formData.country,
      state: formData.state,
      billingAddress: formData.billingAddress,
    };

    if (data.gst) {
      data.companyNameAsPerGst = formData.gstCompanyName;
      data.gstNumber = formData.gstNumber;
    }

    // update form
    if (isFormUpdate) {
      try {
        const res = await axios.patch(
          `${process.env.SERVER_BASE_URL}/billing-info/update/${formData._id}`,
          data
        );
        setIsShowOldBillingInfo(true);
        toast.success("Billing details updated successfully!", toastOptions);
      } catch (error) {
        if (error?.response?.data?.status == "error") {
          toast.error(error?.response?.data?.message, toastOptions);
        } else {
          toast.error("Something wents wrong!", toastOptions);
        }
        return;
      }
    } else {
      try {
        const res = await axios.post(
          `${process.env.SERVER_BASE_URL}/billing-info/post`,
          data
        );
        toast.success("New billing details added successfully!", toastOptions);
        setIsForm(false);
      } catch (error) {
        if (error?.response?.data?.status == "error") {
          toast.error(error?.response?.data?.message, toastOptions);
        } else {
          toast.error("Something wents wrong!", toastOptions);
        }
        return;
      }
    }
    setIsGetBillingData((prev) => !prev);
    setFormData({});
  };

  // handle delete
  const handleDelete = async (id) => {
    try {
      let res = await axios.delete(
        `${process.env.SERVER_BASE_URL}/billing-info/deleteOne/${id}`
      );
      setIsGetBillingData((prev) => !prev);
      toast.success("Billing address deleted successfully!", toastOptions);
    } catch (error) {
      toast.error("something wents wrong!", toastOptions);
      // console.log(error);
    }
  };

  // handle update billing info
  const handleUpdateBillingInfo = async (id) => {
    setIsShowOldBillingInfo(false);
    setIsFormUpdate(true);

    const foundData = userBillingInfo?.find((item) => item._id == id);

    const countryData = countriesData.find(
      (c) => c.name === foundData?.country
    );
    setStates(countryData ? countryData.states : []);

    setFormData({
      ...foundData,
      isGstRequired: foundData?.gst,
      gstCompanyName: foundData?.gstInfo?.companyNameAsPerGst,
      gstNumber: foundData?.gstInfo?.gstNumber,
    });
  };

  return (
    <div className="flex-col-center billingFormContainer">
      <p className="billingHeading">Billing Info</p>
      {/* recent billing info */}
      {isShowOldBillingInfo && userBillingInfo?.length > 0 ? (
        <div className="flex-col-center recentBillingInfoContainer">
          <div className="flex-col-center recentBillingCardWrapper">
            {userBillingInfo.map((item, idx) => {
              return (
                <div key={idx} className="flex-row-center recentBillingCard">
                  <input
                    type="radio"
                    name="currentAddress"
                    onChange={() => handleAddressChange(item)}
                    checked={currentBilling?._id == item._id}
                    value={item._id}
                    className="radioAddress"
                  />
                  <div className="flex-col-center addressBillingBox">
                    <p className="boxTitleBillingCard">{item.name}</p>
                    <p className="boxBillingAddressName">
                      {item.billingAddress}
                    </p>
                  </div>
                  <MdEdit
                    className="actionIcon flex-row-center"
                    onClick={() => handleUpdateBillingInfo(item._id)}
                  />
                  <MdDelete
                    className="actionIcon flex-row-center"
                    onClick={() => handleDelete(item._id)}
                  />
                </div>
              );
            })}
          </div>

          <div className="flex-col-center buttonContainerBilling">
            {/* continue btn */}
            <button className="buttonBilling" onClick={() => setIsForm(false)}>
              Continue
            </button>

            {/* new btn */}
            <button
              className="buttonBilling"
              onClick={() => setIsShowOldBillingInfo(false)}
            >
              New
            </button>
          </div>
        </div>
      ) : (
        <form className="flex-col-center billingForm" onSubmit={handleSubmit}>
          {/* name */}
          <div className="flex-col-center formFieldBilling">
            <label className="labelBilling">Name:</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="inputBilling"
              placeholder="Enter Your name"
              required
            />
          </div>

          {/* contact number */}
          <div className="flex-col-center formFieldBilling">
            <label className="labelBilling">Contact:</label>
            <input
              type="number"
              name="contact"
              value={formData.contact}
              onChange={handleChange}
              required
              className="inputBilling"
              placeholder="Enter Contact Number"
            />
          </div>

          {/* email */}
          <div className="flex-col-center formFieldBilling">
            <label className="labelBilling">Email:</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="inputBilling"
              placeholder="Enter Your Email"
            />
          </div>

          {/* billing address */}
          <div className="flex-col-center formFieldBilling">
            <label className="labelBilling">Billing Address:</label>
            <input
              type="text"
              name="billingAddress"
              value={formData.billingAddress}
              onChange={handleChange}
              required
              className="inputBilling"
              placeholder="Enter Billing Address "
            />
          </div>

          {/* country */}
          <div className="flex-col-center formFieldBilling">
            <label>Country</label>
            <select
              value={formData.country}
              onChange={handleCountryChange}
              required
              className="inputBilling"
            >
              <option value="">select country</option>
              {countriesData.map((item, index) => (
                <option key={index} value={item.name}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          {/* state */}
          <div className="flex-col-center formFieldBilling">
            <label>State</label>
            <select
              value={formData.state}
              onChange={handleStateChange}
              required
              className="inputBilling"
            >
              <option value="" className="optionInputBilling">
                select State
              </option>
              {states?.map((item, index) => (
                <option key={index} value={item.name}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          {/* city */}
          <div className="flex-col-center formFieldBilling">
            <label className="labelBilling">Pin Code:</label>
            <input
              type="number"
              name="pincode"
              value={formData.pincode}
              onChange={handleChange}
              required
              className="inputBilling"
              placeholder="Enter Pincode"
            />
          </div>

          {/* gst required */}
          <div className="flex-col-center formFieldBilling">
            <label className="labelBilling checkLabel flex-row-center">
              GST Bill Required?
              <input
                type="checkbox"
                name="isGstRequired"
                checked={formData.isGstRequired}
                onChange={handleChange}
                className="inputBillingCheck"
              />
            </label>
          </div>

          {/* gst details */}
          {formData.isGstRequired && (
            <>
              <div className="flex-col-center formFieldBilling">
                <label className="labelBilling">Company Name (GST):</label>
                <input
                  type="text"
                  name="gstCompanyName"
                  value={formData.gstCompanyName}
                  onChange={handleChange}
                  required
                  className="inputBilling"
                  placeholder="Enter Gst Company Name"
                />
              </div>

              <div className="flex-col-center formFieldBilling">
                <label className="labelBilling">GST Number:</label>
                <input
                  type="text"
                  name="gstNumber"
                  value={formData.gstNumber}
                  onChange={handleChange}
                  className="inputBilling"
                  required
                  placeholder="Enter GST Number"
                />
              </div>
            </>
          )}

          {/* submit button */}
          <button
            className="buttonBilling"
            type="submit"
            style={{ marginTop: "1rem" }}
          >
            {isFormUpdate ? "Update" : "Proceed to Pay"}
          </button>
        </form>
      )}
    </div>
  );
}
